import { render, staticRenderFns } from "./menuConfig.vue?vue&type=template&id=4fe23e28&scoped=true&"
import script from "./menuConfig.vue?vue&type=script&lang=js&"
export * from "./menuConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe23e28",
  null
  
)

export default component.exports